module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form class="photoInputForm">\n    <div>\n        <label class="photoInputFormLabel newPhotoLabelPosition" for="title">Titre</label>\n        <input class="photoInputFormInput titleInput formInput" type="text" name="title"><br>\n    </div>\n</form>';

}
return __p
}